document.addEventListener('DOMContentLoaded', function(){

  // sticky header
  const header = document.querySelector('.fn-header');
  const headerOffset = header.offsetTop;
  const headerHeight = header.clientHeight + headerOffset;

  if (header) {
    window.onscroll = function() {
      stickyHeaderFunction();
    };

    const stickyHeaderFunction = () => {
      if (window.pageYOffset > 10) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    }
  };

  const stickyContent = document.querySelector('.fn-sticky-content');
  const sticky = document.querySelector('.fn-sticky');
  if (stickyContent && sticky) {
    window.onscroll = function() {
      stickyContentFunction();
    };

    const stickyContentOffset = stickyContent.offsetTop;

    const stickyContentFunction = () => {
      if (window.pageYOffset > stickyContentOffset - headerHeight) {
        sticky.style.top = headerHeight + 'px';
        sticky.classList.add('is-sticky');
      } else {
        sticky.classList.remove('is-sticky');
        sticky.style.top = 0;
      }
    }
  };

  const naviButtons = document.querySelectorAll('.fn-navi-button');
  const naviWrap = document.querySelector('.fn-navi-wrap');
  if (naviWrap && naviButtons.length > 0) {
    const toggleActive = wrap => wrap.classList.toggle('is-active');
    naviButtons.forEach(button => {
      button.addEventListener('click', () => {
        toggleActive(naviWrap);
      });
    });

    naviWrap.addEventListener('click', event => {
      if (event.target.className === 'bg') {
        toggleActive(naviWrap);
      }
    });
  }

  const accordionButton = document.querySelector('.fn-accordion-button');
  if (accordionButton) {
    accordionButton.addEventListener('click', element => {
      const accordionWrap = element.currentTarget.parentNode;
      accordionWrap.classList.toggle('is-active');
    });
  }

  const pageTopBtn = document.querySelector('.fn-pagetop');
  if (pageTopBtn) {
    pageTopBtn.addEventListener('click', function scrollUp() {
      const nowY = window.pageYOffset;
      window.scrollTo(0, Math.floor(nowY * 0.8));
      if (nowY > 0) {
        window.setTimeout(scrollUp, 10);
      }
    });
  }

  // const modalSliderClass = '.fn-modal-slider';
  const modalSlider = document.querySelector('.fn-modal-slider');
  if (modalSlider) {
    baguetteBox.run('.fn-modal-slider', { loop: true });
  }

  const modalSliderClass = '.fn-modal-single';
  const modalSingle = document.querySelector(modalSliderClass);
  if (modalSingle) {
    baguetteBox.run('.fn-modal-single', { buttons: true });
  }

  jQuery(function($){
    // smooth scroll
    const offsetY = -headerHeight;
    const time = 500;

    $('.fn-smooth-link').click(function() {
      const target = $(this.hash);
      if (!target.length) return;
      const targetY = target.offset().top + offsetY;
      $('html,body').animate({ scrollTop: targetY }, time, 'swing');
      window.history.pushState(null, null, this.hash);
      return false;
    });

    // Change format for file of form
    $('.fn-file-input').change(function() {
         var val = $(this).val();
         var path = val.replace(/\\/g, '/');
         var match = path.lastIndexOf('/');
    $('.fn-filename').css("display","inline-block");
         $('.fn-filename').val(match !== -1 ? val.substring(match + 1) : val);
    });
    $('.fn-filename').bind('keyup, keydown, keypress', function() {
        return false;
    });
    $('.fn-filename, .fn-file-input-button').click(function() {
        $('.fn-file-input').click();
    });

    $('.fn-select-scroll-link').change(function () {
      var speed = 400;
      var href = $(this).val();
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top + offsetY;
      $('body,html').animate({
        scrollTop: position
      }, speed, 'swing');
      return false;
    });

    $('.fn-select-link').change(function () {
      location = $(this).val();
      return false;
    });

    const areaSelect = $('.fn-area-select');
    const areaLinks = $('.fn-area-link');
    const areaChildLinks = $('.fn-child-area-link');
    const areaWrap = $('.fn-area-wrap');

    const addAreaWrap = (area, isAll = false, isFirst = false) => {

      if (isFirst) {
        const thisArea = $(areaWrap[0]);
        if(!thisArea.hasClass('is-active')) {
          thisArea.addClass('is-active');
        }

      } else {

        for(let i = 0; i < areaWrap.length; i++) {
          const thisArea = $(areaWrap[i]);

          if (isAll) {
            if (!thisArea.hasClass('is-active')) {
              thisArea.addClass('is-active');
            }

          } else if (area && (area === thisArea.attr('id'))) {
            if (!thisArea.hasClass('is-active')) {
              thisArea.addClass('is-active');
            }

          } else {
            thisArea.removeClass('is-active');
          }
        }

      }
    }

    if (areaSelect.length > 0) {
      addAreaWrap(null, true, false);

      areaSelect.change(function(e) {
        e.preventDefault();
        const target = e.currentTarget.value;
        addAreaWrap(target.replace('#', ''), (target == ''), false);
      });
      
    } else if (areaLinks.length > 0) {
      addAreaWrap(null, false, true);
      areaLinks[0].classList.add('is-active');

      areaLinks.click(function(e) {
        e.preventDefault();
        const target = e.currentTarget.hash;
        addAreaWrap(target.replace('#', ''), false, false);
        if ($('.fn-area-link.is-active')) {
          $('.fn-area-link.is-active').removeClass('is-active');
        }
        $(this).addClass('is-active');
      });

    }

    if (areaChildLinks.length > 0) {
      areaChildLinks.click(function(e) {
        e.preventDefault();
        const currentTarget = e.currentTarget;
        const hash = currentTarget.hash;
        if (!hash.length) return;

        const area = $(currentTarget).parents('.fn-child-area-link-parent').data('child-area');

        addAreaWrap(area, false, false);

        for(let i = 0; i < areaLinks.length; i++) {
          const thisLink = $(areaLinks[i]);
          if (thisLink.attr('href') === `#${area}`) {
            thisLink.addClass('is-active');
          } else {
            thisLink.removeClass('is-active');
          }
        }

        const target = $(hash);
        const targetY = target.offset().top + offsetY;
        $('html,body').animate({ scrollTop: targetY }, time, 'swing');
        window.history.pushState(null, null, this.hash);
        return false;

      });
    }

    const sliderContainer = document.querySelector('.fn-slider-container');
    if (sliderContainer) {
      $(sliderContainer).slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        fade: true,
        dots: true,
        infinite: true,
        cssEase: 'linear',
        lazyLoad: 'ondemand',
      });
      $(document).on('beforeChange', sliderContainer, function(event, slick, currentSlide, nextSlide){
        var nextSlide = slick.$slides.get(nextSlide);
        var $slideSoureSets = $(nextSlide).find('source');
        $($slideSoureSets).each(function () {
          $(this).attr('srcset', $(this).data('lazy'));
        });
      });
    }
  });

}, false);
